/* eslint-disable */
export default {
  419: '라틴 아메리카',
  AR: '아르헨티나',
  AT: '오스트리아',
  AU: '호주',
  BE: '벨기에',
  BG: '불가리아',
  BH: '바레인',
  BJ: '베냉',
  BR: '브라질',
  CA: '캐나다',
  CH: '스위스',
  CL: '칠레',
  CN: '중국',
  CO: '콜롬비아',
  CY: '사이프러스',
  CZ: '체코 공화국',
  DE: '독일',
  DK: '덴마크',
  DO: '도미니카 공화국',
  EE: '에스토니아',
  ES: '스페인',
  FI: '핀란드',
  FR: '프랑스',
  GB: '영국',
  GE: '조지아',
  GH: '가나',
  GN: '기니',
  GR: '그리스',
  HK: '홍콩',
  HR: '크로아티아',
  HU: '헝가리',
  ID: '인도네시아',
  IE: '아일랜드',
  IL: '이스라엘',
  IN: '인도',
  IT: '이탈리아',
  JP: '일본',
  KE: '케냐',
  KR: '대한민국',
  LT: '리투아니아',
  LU: '룩셈부르크',
  LV: '라트비아',
  MX: '멕시코',
  MY: '말레이시아',
  NG: '나이지리아',
  NL: '네덜란드',
  NO: '노르웨이',
  NZ: '뉴질랜드',
  PA: '파나마',
  PE: '페루',
  PH: '필리핀',
  PK: '파키스탄',
  PL: '폴란드',
  PR: '푸에르토리코',
  PT: '포르투갈',
  RO: '루마니아',
  SE: '스웨덴',
  SG: '싱가포르',
  SI: '슬로베니아',
  SK: '슬로바키아',
  SV: '엘살바도르',
  TR: '튀르키예',
  TW: '대만',
  UA: '우크라이나',
  US: '미국',
  VN: '베트남',
  ZA: '남아프리카 공화국',
} as const;

// @key: @#@"419"@#@ @source: @#@"Latin America"@#@
// @key: @#@"AR"@#@ @source: @#@"Argentina"@#@
// @key: @#@"AT"@#@ @source: @#@"Austria"@#@
// @key: @#@"AU"@#@ @source: @#@"Australia"@#@
// @key: @#@"BE"@#@ @source: @#@"Belgium"@#@
// @key: @#@"BG"@#@ @source: @#@"Bulgaria"@#@
// @key: @#@"BH"@#@ @source: @#@"Bahrain"@#@
// @key: @#@"BJ"@#@ @source: @#@"Benin"@#@
// @key: @#@"BR"@#@ @source: @#@"Brazil"@#@
// @key: @#@"CA"@#@ @source: @#@"Canada"@#@
// @key: @#@"CH"@#@ @source: @#@"Switzerland"@#@
// @key: @#@"CL"@#@ @source: @#@"Chile"@#@
// @key: @#@"CN"@#@ @source: @#@"China"@#@
// @key: @#@"CO"@#@ @source: @#@"Colombia"@#@
// @key: @#@"CY"@#@ @source: @#@"Cyprus"@#@
// @key: @#@"CZ"@#@ @source: @#@"Czech Republic"@#@
// @key: @#@"DE"@#@ @source: @#@"Germany"@#@
// @key: @#@"DK"@#@ @source: @#@"Denmark"@#@
// @key: @#@"DO"@#@ @source: @#@"Dominican Republic"@#@
// @key: @#@"EE"@#@ @source: @#@"Estonia"@#@
// @key: @#@"ES"@#@ @source: @#@"Spain"@#@
// @key: @#@"FI"@#@ @source: @#@"Finland"@#@
// @key: @#@"FR"@#@ @source: @#@"France"@#@
// @key: @#@"GB"@#@ @source: @#@"United Kingdom"@#@
// @key: @#@"GE"@#@ @source: @#@"Georgia"@#@
// @key: @#@"GH"@#@ @source: @#@"Ghana"@#@
// @key: @#@"GN"@#@ @source: @#@"Guinea"@#@
// @key: @#@"GR"@#@ @source: @#@"Greece"@#@
// @key: @#@"HK"@#@ @source: @#@"Hong Kong"@#@
// @key: @#@"HR"@#@ @source: @#@"Croatia"@#@
// @key: @#@"HU"@#@ @source: @#@"Hungary"@#@
// @key: @#@"ID"@#@ @source: @#@"Indonesia"@#@
// @key: @#@"IE"@#@ @source: @#@"Ireland"@#@
// @key: @#@"IL"@#@ @source: @#@"Israel"@#@
// @key: @#@"IN"@#@ @source: @#@"India"@#@
// @key: @#@"IT"@#@ @source: @#@"Italy"@#@
// @key: @#@"JP"@#@ @source: @#@"Japan"@#@
// @key: @#@"KE"@#@ @source: @#@"Kenya"@#@
// @key: @#@"KR"@#@ @source: @#@"South Korea"@#@
// @key: @#@"LT"@#@ @source: @#@"Lithuania"@#@
// @key: @#@"LU"@#@ @source: @#@"Luxembourg"@#@
// @key: @#@"LV"@#@ @source: @#@"Latvia"@#@
// @key: @#@"MX"@#@ @source: @#@"Mexico"@#@
// @key: @#@"MY"@#@ @source: @#@"Malaysia"@#@
// @key: @#@"NG"@#@ @source: @#@"Nigeria"@#@
// @key: @#@"NL"@#@ @source: @#@"Netherlands"@#@
// @key: @#@"NO"@#@ @source: @#@"Norway"@#@
// @key: @#@"NZ"@#@ @source: @#@"New Zealand"@#@
// @key: @#@"PA"@#@ @source: @#@"Panama"@#@
// @key: @#@"PE"@#@ @source: @#@"Peru"@#@
// @key: @#@"PH"@#@ @source: @#@"Philippines"@#@
// @key: @#@"PK"@#@ @source: @#@"Pakistan"@#@
// @key: @#@"PL"@#@ @source: @#@"Poland"@#@
// @key: @#@"PR"@#@ @source: @#@"Puerto Rico"@#@
// @key: @#@"PT"@#@ @source: @#@"Portugal"@#@
// @key: @#@"RO"@#@ @source: @#@"Romania"@#@
// @key: @#@"SE"@#@ @source: @#@"Sweden"@#@
// @key: @#@"SG"@#@ @source: @#@"Singapore"@#@
// @key: @#@"SI"@#@ @source: @#@"Slovenia"@#@
// @key: @#@"SK"@#@ @source: @#@"Slovakia"@#@
// @key: @#@"SV"@#@ @source: @#@"El Salvador"@#@
// @key: @#@"TR"@#@ @source: @#@"Türkiye"@#@
// @key: @#@"TW"@#@ @source: @#@"Taiwan"@#@
// @key: @#@"UA"@#@ @source: @#@"Ukraine"@#@
// @key: @#@"US"@#@ @source: @#@"United States"@#@
// @key: @#@"VN"@#@ @source: @#@"Vietnam"@#@
// @key: @#@"ZA"@#@ @source: @#@"South Africa"@#@
